import axiosInstance from "../../config/axiosInstance";

const getPrefilledData = async (param: any) => {
  const response = await axiosInstance.post(`/api/entityExtration`, {
    files: param,
  });
  return response;
};

const closeOutService = { getPrefilledData };
export default closeOutService;
